module.exports = __webpack_public_path__ + "img/company_formation_illustration_card.63eac1d6.svg";